module.exports = __webpack_public_path__ + "img/lens-160-plus-06.334a5f0d.png";